module.exports = __webpack_public_path__ + "img/gray-mail-icon.80ba6893.svg";